import React from 'react'

import NationalResult from '../../../models/NationalResult'
import Party from '../../../models/Party'
import RegionalResultTableRow from './RegionalResultTableRow'

interface IProps {
  nationalResult: NationalResult
}

class RegionalResultTable extends React.Component<IProps> {
  public render(): JSX.Element {
    const { nationalResult } = this.props

    const partyHeaders = Party.allPartiesArray().map(
      (party): JSX.Element => <th key={party.key}>{party.key}</th>
    )

    const regionalRows = nationalResult
      .regionalResults()
      .map(
        (regionalResult): JSX.Element => (
          <RegionalResultTableRow
            key={regionalResult.region.key}
            regionalResult={regionalResult}
          />
        )
      )

    return (
      <div>
        <h2>Regional results</h2>
        <table className="table text-right">
          <thead>
            <tr>
              <th className="text-right pr-3">Region</th>
              <th></th>
              {partyHeaders}
            </tr>
          </thead>
          <tbody>{regionalRows}</tbody>
        </table>
      </div>
    )
  }
}

export default RegionalResultTable
